import $ from 'jquery';
import slick from 'slick-carousel';
import * as CONST from '../utils/constants';
import Util from '../utils/ui'; 

class OfficeTestimonial {
    constructor(target, settings) {
        
    }

    init() {
        this.officeTestimonialSlider();
    }

    officeTestimonialSlider() {
        let $slickElement = $('.office-testimonial-list');

        $slickElement.on('init reInit afterChange', (event, slick, currentSlide, nextSlide) => {
            if (currentSlide === undefined) {
                currentSlide = 0;
            }
            
            $('.js-count').text(`${currentSlide + 1} of ${slick.slideCount}`);
        });

        if ($('.office-testimonial-list').length) {
            $('.office-testimonial-list').slick({
                mobileFirst: true,
                slidesToShow: 1.1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: false,
                adaptiveHeight: true,
                customPaging: (slider, i) => '<div class="custom-dot"></div>',
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 2,
                            infinite: true,
                            arrows: true,
                            dots: true,
                            adaptiveHeight: true
                        }
                    }
                ]
            });

            $('.slick-dots li .custom-dot').on('click', (e) => {
                e.stopPropagation();
            });
        }
    }
}

export default OfficeTestimonial;

$(() => {
	const officeTestimonial = new OfficeTestimonial();
	officeTestimonial.init();
});